import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	mainWorkspace: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.monday.main-workspace',
		defaultMessage: 'Main workspace',
		description: 'Name of the main workspace on monday',
	},
});
